export function encodeEmail(input: string): string {
  return btoa(input);
}
